import PropTypes from "prop-types";
import * as React from "react";
import LokalizaceApi from "../api/gen/core/LokalizaceApi";
import {  i18nSetCustomMessages } from "./i18n";import {brandTitle} from "./Message";

export class Languages extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      zpravy: null,
      jazyky: null,
      lang: (window as any).currentLanguage,
    };
  }

  getChildContext() {
    const { lang, jazyky } = this.state;
    return {
      language: {
        currLang: lang,
        allowedLangs: jazyky,
        setLang: (lang) => {
          this.setState({
            lang,
          });
          LokalizaceApi.setJazyk(lang);
        },
      },
    };
  }

    componentDidMount() {
        LokalizaceApi.getZpravy().then(zpravy => {
            i18nSetCustomMessages(zpravy);
            document.title = brandTitle(this.state.lang);

            this.setState({
                zpravy
            });
        });

        LokalizaceApi.getPovoleneJazyky().then(jazyky => {
            this.setState({
                jazyky
            });
        });
    }

  render() {
      const {jazyky, zpravy} = this.state;
      if (jazyky && zpravy) {
          return <div>{this.props.children}</div>;
      } else {
          return <div></div>;
      }
  }
}
Languages.childContextTypes = {
  language: PropTypes.shape({
    currLang: PropTypes.string,
    allowedLangs: PropTypes.arrayOf(PropTypes.string),
    setLang: PropTypes.func,
  }),
};
